exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-indicator {\n  border-radius: 9999px;\n  min-width: 42px;\n  max-width: 25px;\n  max-height: 25px;\n  background-color: #f00;\n}\n.black-indicator {\n  border-radius: 9999px;\n  min-width: 56px;\n  max-width: 40px;\n  max-height: 40px;\n}\n", ""]);

// exports
